import { Injectable } from '@angular/core';
import jsPDF, { jsPDFOptions } from 'jspdf';

@Injectable({ providedIn: 'root' })
export class JsPDFService {
  public create(options?: jsPDFOptions): jsPDF {
    return new jsPDF(options);
  }

  public addPage(pdf: jsPDF): void {
    pdf.addPage();
  }

  public addImage(
    pdf: jsPDF,
    imageData: string,
    format: string,
    x: number,
    y: number,
    width: number,
    height: number
  ): void {
    pdf.addImage(imageData, format, x, y, width, height);
  }

  public save(pdf: jsPDF, fileName: string): void {
    pdf.save(fileName);
  }
}
